import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export default {
  total: function total(state) {
    return state.total;
  },
  items: function items(state) {
    return state.items;
  },
  success: function success(state) {
    return state.success;
  },
  successServer: function successServer(state) {
    return state.successServer;
  },
  state: function state(_state) {
    return _state.cartState;
  }
};